import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';

const SelectEstadoNoLeInteresaPreServicio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: 'NO HAY UN PLAN ADECUADO PARA MI',
            label: 'NO HAY UN PLAN ADECUADO PARA MI',
        },
        {
            value: 'ME RESULTA CARO',
            label: 'ME RESULTA CARO',
        },
        {
            value: 'NO TENGO APURO EN CONTRATAR EL SERVICIO',
            label: 'NO TENGO APURO EN CONTRATAR EL SERVICIO',
        },
        {
            value: 'NO LE TENGO CONFIANZA',
            label: 'NO LE TENGO CONFIANZA',
        },
        {
            value: 'NO ME ASESORARON CORRECTAMENTE',
            label: 'NO ME ASESORARON CORRECTAMENTE',
        },
        {
            value: 'NECESITO CONSULTARLO CON OTRA PERSONA',
            label: 'NECESITO CONSULTARLO CON OTRA PERSONA',
        },
        {
            value: 'OTROS',
            label: 'OTROS',
        },
        {
            value: 'ESTOY CONSULTANDO PRECIOS/PROMOCIONES',
            label: 'ESTOY CONSULTANDO PRECIOS/PROMOCIONES',
        },
        {
            value: 'NO TIENEN PROMOCIONES',
            label: 'NO TIENEN PROMOCIONES',
        },
        {
            value: 'NO TIENE SERVICIOS ADICIONALES',
            label: 'NO TIENE SERVICIOS ADICIONALES',
        },
        {
            value: 'NO TENGO TC',
            label: 'NO TENGO TC',
        },
        {
            value: 'NO COTIZAN EN MONEDA NACIONAL',
            label: 'NO COTIZAN EN MONEDA NACIONAL',
        },
        {
            value: 'PLAZO DE ESPERA EN FECHA DE INSTALACION',
            label: 'PLAZO DE ESPERA EN FECHA DE INSTALACION',
        },
        {
            value: 'INSTALACION CANCELADA',
            label: 'INSTALACION CANCELADA'
        },
        {
            value: 'CANCELADO POR FALTA DE DOCUMENTACIÓN',
            label: 'CANCELADO POR FALTA DE DOCUMENTACIÓN'
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectEstadoNoLeInteresaPreServicio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectEstadoNoLeInteresaPreServicio;